module.exports = __webpack_public_path__ + "img/login.13ff29a5.jpg";